import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { PulseLoader } from 'react-spinners'
import { Card, FormGroup, Form, Button } from 'react-bootstrap'

import { getServerUrl } from '../../../functions/getServerUrl'

import LoadingScreen from '../../../components/LoadingScreen'

import { setUser } from '../reducers/loginReducer'

class PasswordReset extends Component {

  state = {
    checkingToken: true,
    tokenIsValid: false,
    newPassword: '',
    confirmNewPassword: '',
    savingNewPassword: false,
    currentUser: {},
  }


  componentDidMount() {
    this.checkToken()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.routerProps.match.params.token !== this.getToken() || prevProps.routerProps.match.params.token_id !== this.getTokenId()) {
      this.checkToken()
    }
  }

  getToken = () => {
    let token
    try {
      token = this.props.routerProps.match.params.token
    } catch (error) {
      token = null
    }

    return token
  }

  getTokenId = () => {
    let tokenId
    try {
      tokenId = this.props.routerProps.match.params.token_id
    } catch (error) {
      tokenId = null
    }

    return tokenId
  }


  checkToken = () => {
    const token = this.getToken()
    const token_id = this.getTokenId()

    axios({
      method: "POST",
      url: `${getServerUrl()}/recover-password-token-check/`,
      data: { token, token_id },
    })
    .then((response) => {
      return this.setState({
        checkingToken: false,
        tokenIsValid: true,
        currentUser: response.data,
      })
    })
    .catch(error => {
      return this.setState({
        checkingToken: false,
        tokenIsValid: false,
      })
    })
  }


  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      return this.saveNewPassword()
    }
  }


  saveNewPassword = () => {
    const { newPassword, confirmNewPassword } = this.state
    const token = this.getToken()
    const token_id = this.getTokenId()

    if (newPassword !== confirmNewPassword) {
      return this.props.alert.show('New passwords do not match')
    }

    if (newPassword.length < 8) {
      return this.props.alert.show('Your new password must be at least 8 characters in length')
    }

    this.setState({ savingNewPassword: true })

    axios({
      method: "PATCH",
      url: `${getServerUrl()}/recover-password/`,
      data: {
        new_password: newPassword,
        token,
        token_id,
      }
    })
    .then(response => {
      this.setState({
        savingNewPassword: false,
        newPassword: '',
        confirmNewPassword: '',
      })

      localStorage.setItem('jwt', response.data.token)
      this.props.setUser(this.state.currentUser)

      const message = "Your password has been changed"

      const options = {
        position: 'bottom center',
        type: 'success',
        onClose: () => this.props.routerProps.history.push('/'),
      }

      return this.props.alert.show(message, options)
    })
    .catch(error => {
      let errorMessage
      this.setState({ savingNewPassword: false })
      if (error && error.response && error.response.data && error.response.data.non_field_errors) {
        errorMessage = error.response.data.non_field_errors
      } else if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      } else {
        errorMessage = 'An error occured while attempting to save your new password. Please try again.'
      }

      return this.props.alert.show(errorMessage)
    })
  }


  render() {

    const { newPassword, confirmNewPassword, savingNewPassword, checkingToken,
    tokenIsValid } = this.state

    if (checkingToken === true) {
      return (
        <LoadingScreen text='Verifying user' />
      )
    } else if (tokenIsValid === false) {
      return (
        <div id="PasswordReset" className='login-body'>
          <center>
            <h2>
              Unable to authorize password reset
            </h2>
            <h5>
              Your password reset link is either invalid or has expired. To request a new one, please go to the login page.
            </h5>

            <br/>

            <Button onClick={() => this.props.routerProps.history.replace('/')}>
              Back
            </Button>
          </center>
        </div>
      )
    } else {
      return (
        <div id="PasswordReset" className='login-body'>
          <Card id="PasswordResetCard">
            <Card.Header>
              {this.state.currentUser.first_name ?
                `Reset Password - ${this.state.currentUser.first_name} ${this.state.currentUser.last_name}`
                :
                'Reset Password'
              }
            </Card.Header>
            <Card.Body onKeyDown={this.handleEnterPress}>
              <p>
                Passwords must be at least 8 characters in length.
              </p>

              <FormGroup>
                <Form.Label>
                  New Password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                >
                </Form.Control>
                <Form.Control.Feedback />
              </FormGroup>

              <FormGroup>
                <Form.Label>
                  Confirm New Password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="confirmNewPassword"
                  value={confirmNewPassword}
                  onChange={this.handleChange}
                >
                </Form.Control>
                <Form.Control.Feedback />
              </FormGroup>

              <br/>

              <center>
                <Button
                  onClick={this.saveNewPassword}
                  style={{minWidth: '50%'}}
                >
                  {savingNewPassword ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Save'
                  }
                </Button>
              </center>
            </Card.Body>
          </Card>
        </div>
      )
    }
  }
}


export default connect(null, { setUser })(PasswordReset)
